import React from 'react';

import { Pressable } from 'react-native-web';
import analytics from '../../../modules/analytics';

interface TrackedOptionProps {
  name: string;
  testID: string;
  onPress?: () => void;
  children: React.ReactNode;
}

const TrackedOption: React.FC<TrackedOptionProps> = ({
  name,
  testID,
  onPress,
  children,
}) => {
  const trackClick = () => {
    analytics.track(name);
    if (typeof onPress === 'function') {
      onPress();
    }
  };

  return (
    <Pressable onPress={trackClick} testID={testID}>
      {children}
    </Pressable>
  );
};

export default TrackedOption;
